export default __webpack_public_path__ + "static/media/AllProductEyeActive.b2242d20.svg";